import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IconsModule } from "../icons/icons.module";
import { BlinkerComponent } from "./blinker.component";

@NgModule({
  imports: [CommonModule, IconsModule],
  declarations: [BlinkerComponent],
  exports: [BlinkerComponent],
})
export class BlinkerComponentModule { }
